import api from '../api/api';

function getAndSetWasPrice(originalPriceBreaks, cspPriceBreaks) {
  originalPriceBreaks = originalPriceBreaks.reduce((result, pricebreak) => {
    result[`${pricebreak.priceBreakLowerBound}-${pricebreak.priceBreakUpperBound}`] = pricebreak.priceExVat;
    return result;
  }, {});

  cspPriceBreaks.forEach(itemCSP => {
    const originalPrice = originalPriceBreaks[`${itemCSP.priceBreakLowerBound}-${itemCSP.priceBreakUpperBound}`];
    if (originalPrice) {
      itemCSP.wasPriceExVat = originalPrice;
    }
  });
  return cspPriceBreaks;
}

export function GetCustomerSpecificPriceBreaks(productId, originalPriceBreaks) {
  const getCustomerSpecificPriceBreaksUrl = `/web/services/product/${productId}/prices/v1`;

  return api.get(getCustomerSpecificPriceBreaksUrl).then(json => {
    return json && json.length > 0 ? getAndSetWasPrice(originalPriceBreaks, json) : undefined;
  })
    .catch(exception => {
      const error = exception;
      error.statusText = `Call to GetCustomerSpecificPriceBreaks with ${getCustomerSpecificPriceBreaksUrl} failed. ${exception.statusText}`;
      return Promise.reject(error);
    });
}

export function CheckProductSensitivity(productId, rsStockNumber) {
  const checkProductSensitivityUrl = `/web/services/productdetails/productsensitivity/${productId}/${rsStockNumber}`;

  return api.get(checkProductSensitivityUrl)
    .catch(exception => {
      const error = exception;
      error.statusText = `Call to CheckProductSensitivity with ${checkProductSensitivityUrl} failed. ${exception.statusText}`;
      return Promise.reject(error);
    });
}



// WEBPACK FOOTER //
// ./src/main/ui/react/shared/services/Product/Product.js